import {Component} from '@angular/core';

@Component({
    selector: 'page-header-block',
    templateUrl: './page-header-block.component.html',
})
export class PageHeaderBlockComponent {

}
